module.exports = __webpack_public_path__ + "static/media/motel-otay-logotipo.29b95469.png";